import React from "react"

interface SimulationButtonProps {
  onClick?: React.MouseEventHandler<SVGSVGElement> // onClick의 타입 정의
}

const SimulationButton: React.FC<SimulationButtonProps> = ({ onClick }) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick} // onClick 프롭스 추가
      style={{ cursor: "pointer" }} // 커서 포인터 스타일 추가
    >
      <path
        d="M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36ZM26.7889 16.8415C27.6656 17.3653 27.6656 18.6352 26.789 19.1591L15.6638 25.8079C14.3141 26.6146 12.6 25.6422 12.6 24.0697V11.9311C12.6 10.3587 14.314 9.38625 15.6638 10.1929L26.7889 16.8415Z"
        fill="white"
      />
    </svg>
  )
}

export default SimulationButton
